import React from "react";
import {
  ArrowUpRight,
  Award,
  Headphones,
  Laptop,
  Users,
  Wallet,
} from "lucide-react";
import "./BootcampSuccessSection.css";

const successItems = [
  {
    id: "certificate",
    icon: Award,
    trend: "gold",
    title: "Earn a certificate of completion",
    body: "Starting you on the way to a Diploma in Financial Trading",
  },
  {
    id: "trade-support",
    icon: Headphones,
    trend: "green",
    title: " Live 1:1 Trader Mentor Support",
    body: "Trade live with the support of professional traders",
  },
  {
    id: "mentor-sessions",
    icon: Users,
    trend: "red",
    title: "Fully Personalized Trade Plan",
    body: "Develop a fully personalized trade plan with your mentor to guide your trading journey",
  },
  {
    id: "part-time-online",
    icon: Laptop,
    trend: "green",
    title: "Study Part time Online",
    body: "Study on Unity, part time and from anywhere in the world",
  },
  {
    id: "funded-account",
    icon: Wallet,
    trend: "gold",
    title: "Complete with a $15,000 Funded Account",
    body: "Complete your bootcamp and start your funded account challenge with TPC",
    featured: true,
  },
];

const marketCandles = [
  "green",
  "green",
  "red",
  "green",
  "gold",
  "red",
  "green",
  "green",
  "red",
  "green",
];

function BootcampSuccessSection() {
  return (
    <section className="trpc-success" aria-labelledby="trpc-success-title">
      <div className="trpc-success-marketLayer" aria-hidden="true">
        <span className="trpc-success-priceLine trpc-success-priceLine--one" />
        <span className="trpc-success-priceLine trpc-success-priceLine--two" />

        <div className="trpc-success-candleGroup">
          {marketCandles.map((trend, index) => (
            <span
              key={`${trend}-${index}`}
              className="trpc-success-candle"
              data-trend={trend}
            />
          ))}
        </div>
      </div>

      <div className="trpc-success-shell">
        <div className="trpc-success-header">
          <div className="trpc-success-terminalTop" aria-hidden="true">
            <span />
            <span />
            <span />
          </div>

          <span className="trpc-success-kicker">TPC Bootcamp Advantage</span>

          <h2 id="trpc-success-title" className="trpc-success-title">
            Everything you need to succeed
          </h2>

          <p className="trpc-success-subtitle">
            Practical Hands-on learning. Live Market Action. Personal support.
            Results-focused outcomes.
          </p>
        </div>

        <ul className="trpc-success-grid" aria-label="Bootcamp benefits">
          {successItems.map((item, index) => {
            const Icon = item.icon;

            return (
              <li
                className={
                  item.featured
                    ? "trpc-success-card trpc-success-card-featured"
                    : "trpc-success-card"
                }
                key={item.id}
                data-trend={item.trend}
                style={{ "--card-index": index }}
              >
                <span className="trpc-success-cardGlow" aria-hidden="true" />

                <span className="trpc-success-cardNumber" aria-hidden="true">
                  {String(index + 1).padStart(2, "0")}
                </span>

                <span className="trpc-success-icon" aria-hidden="true">
                  <Icon size={25} strokeWidth={2.15} />
                </span>

                <div className="trpc-success-cardCopy">
                  <h3 className="trpc-success-cardTitle">{item.title}</h3>
                  <p className="trpc-success-cardText">{item.body}</p>
                </div>
              </li>
            );
          })}
        </ul>

        <div className="trpc-success-actionRow">
          <a
            className="trpc-success-cta"
            href="https://andus.co.za/trade-register"
            target="_blank"
            rel="noopener noreferrer"
            data-candle="green"
          >
            <span>Apply now</span>
            <ArrowUpRight size={17} strokeWidth={2.4} aria-hidden="true" />
          </a>
        </div>
      </div>
    </section>
  );
}

export default BootcampSuccessSection;